import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { to_API_URL } from '../Services/RestService';
// https://api.test.onepush.studio

const LoginPage = (props: { onLoginSucessfull: () => {} }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [cookies, setCookie] = useCookies(['accessToken', 'refreshToken']);


  // Check if email is valid to show password field
  useEffect(() => {
    // Basic email validation
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    setShowPassword(isValidEmail && email.length > 0);

    // Clear any previous errors when input changes
    if (error) setError('');
  }, [email]);

  const handleSubmit = (e: any) => {
    e.preventDefault();

    // Basic form validation
    if (!email) {
      setError('Email is required');
      return;
    }

    if (showPassword && !password) {
      setError('Password is required');
      return;
    }

    // Simulate login process
    setIsLoading(true);
    setError('');
    fetch(to_API_URL('api/v1/auth/login'), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "*/*",
        "Cache-Control":"no-cache",
        "Connection":"keep-alive",
        "Host":"localhost:3001",
        
      },
      body: JSON.stringify({
        email,
        password
      })
    })
      .then(res => res.json() as unknown as { access_token: string, refresh_token: string })
      .then(res => { setCookie("accessToken", res.access_token); setCookie("refreshToken", res.refresh_token); setIsLoading(false); props.onLoginSucessfull() })
      .catch(err => {
        console.log("Failed to login", err);
        setIsLoading(false);
        setError("Login Failed");
      })
  };



  return (
    <div style={{ backgroundColor: "#A89EE4" }} className="min-h-screen flex flex-col justify-center">
      <div style={{ marginTop: 26, backgroundColor: "white" }} className="mx-auto w-full max-w-md">
        {/* Logo and Header */}
        <div style={{ marginTop: 24 }} className="text-center mb-10">
          <div className="mx-auto w-16 h-16 bg-white rounded-full flex items-center justify-center mb-4">
            <svg width="178" height="165" viewBox="0 0 178 165" xmlns="http://www.w3.org/2000/svg">
              <g id="Icon">
                <path id="Rectangle 564" d="M9 76.3572H168.726V88.5811H9V76.3572Z" fill="#443A43" />
                <path id="Rectangle 565" d="M22.7568 37.2446L161.083 117.107L154.971 127.694L16.6449 47.8308L22.7568 37.2446Z" fill="#443A43" />
                <path id="Rectangle 566" d="M135.795 149.034L123.044 156.396L41.9311 15.9043L54.6821 8.54247L135.795 149.034Z" fill="#A89EE4" stroke="#FFFDF5" stroke-width="2.5" />
              </g>
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-800">Dashboard v1.0</h1>
          <p className="text-gray-600 mt-2">Sign in to access your account</p>
        </div>

        {/* Login Form */}
        <div className="bg-white py-8 px-6 shadow rounded-lg">
          {error && (
            <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="appearance-none block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="you@example.com"
                />
              </div>
              {!showPassword && email && (
                <p className="mt-2 text-sm text-gray-500">
                  Please enter a valid email address
                </p>
              )}
            </div>

            {/* Password field - only shown after valid email */}
            {showPassword && (
              <div className="mb-6 animate-fadeIn">
                <div className="flex items-center justify-between">
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                    Password
                  </label>
                  <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-500">
                    Forgot password?
                  </a>
                </div>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="appearance-none block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="••••••••"
                  />
                </div>
              </div>
            )}

            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700">
                  Remember me
                </label>
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={isLoading || (!showPassword || (showPassword && !password))}
                className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 focus:outline-none ${isLoading || (!showPassword || (showPassword && !password))
                  ? 'opacity-70 cursor-not-allowed'
                  : 'hover:bg-blue-700 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'
                  }`}
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Signing in...
                  </>
                ) : (
                  'Sign in'
                )}
              </button>
            </div>
          </form>


        </div>


      </div>

      {/* Footer */}
      <footer className="mt-auto py-4">
        <div className="text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Your Company. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default LoginPage;

